export default __webpack_public_path__ + "static/media/Montserrat-Light-300.f0963fd9.ttf";